import { useDebugKeyChangePage } from "./useDebugKeyChangePage";
import { useDebugKeyEventbus } from "./useDebugKeyEventbus";
import { useDebugKeyMenuMessage } from "./useDebugKeyMenuMessage";
import { useDebugKeyDialogMessage } from "./useDebugKeyDialog";
import { useDebugKeyCheckVideos } from "./useDebugKeyCheckVidoes";

export function useAppDebug() {

    useDebugKeyChangePage()
    useDebugKeyEventbus(false)
    useDebugKeyCheckVideos()

    // useDebugKeyMenuMessage()
    useDebugKeyDialogMessage()
    
    
    return {}
}